import BOOKING from './booking.services';
import ISSUANCE from './issuance.services';
import EBOOKS from './eBooks.services';
import PACKAGES from './packages.services';
import BOOKS from './books.services';
import ROOMS from './rooms.services';
import PRINTING from './printing.services';

const SERVICES = {
	BOOKING,
	ISSUANCE,
	EBOOKS,
	PACKAGES,
	ROOMS,
	BOOKS,
	PRINTING
};

export default SERVICES;
